<template>
	<section>
		<transition mode="out-in" name="leftIn">
			<div v-if="connect">

				<div v-if="user">
					<password :user="user" />
				</div>

				<div v-else class="text-center w-75 m-auto">
					<h4 class="text-dark-50 text-center mt-0 font-weight-bold">Pedido não localizado</h4>
					<p>Não foi possível localizar sua solicitação de recuperação de senha. Vale ressaltar que o link fornecido por email funciona apenas uma vez.</p>
				</div>
					
				<div class="row mt-3">
					<div class="col-12 text-center">
						<p><router-link to="Login" class="text-dark ml-1"><b>Voltar</b></router-link> para tela de login.</p>
					</div>
				</div>  
			</div>

			<div v-else class="text-center w-75 m-auto">
				<h4 class="text-dark-50 text-center mt-0 font-weight-bold">Verificando</h4>
				<loading />
			</div>
		</transition>
	</section>
</template>

<script>
	import password from "./Password.vue"
	import loading  from "@/components/Tools/Loading.vue"
	import api      from "@/mixins/api.js"

	export default {
		name: "check-token",
		components: { loading, password },
		mixins: [ api ],

		data() { return { connect: null, user: null }},

		mounted() {
			this.check(this.$route.query.token)
		},

		methods: {
			async check(token) {
				const response = await this.POST("Auth/Tokenpwd", { token })

				if ( response.status == "success" ) {
					localStorage.token= token
					this.user = response.result
				}


				this.connect  = true
			}
		}
	}
</script>

<style>
</style>